import { FaCrown } from 'react-icons/fa';
import Image from 'next/image';
export default function Thumbnail(props) {
    return (
        <>
            <div className="flex flex-col gap-y-2 justify-center items-center">
                <a href={props.href} rel="noreferrer" target="_blank" className="rounded-2xl relative w-auto overflow-hidden bg-blue-900">
                    <div className="rounded-2xl bg-black opacity-0 hover:opacity-[0.15] absolute w-full h-full top-0 left-0 transition-all ease-in-out duration-200" />
                    <Image 
                        src={props.thumb} 
                        width="128" 
                        height="128" 
                        referrerPolicy="no-referrer"
                        alt="Avatar" 
                        className={`object-cover rounded-2xl w-24 ${props.className}`}
                        onLoadingComplete={() => console.log("Image loaded")}
                    />
                </a>
                <div className="flex flex-col text-center justify-center items-center">
                    <a href={props.href} rel="noreferrer" target="_blank" className={`flex gap-x-2 font-BreezeHeader font-bold text-xl w-fit text-center ${props.me ? "text-yellow-400 hover:text-yellow-600" : "hover:text-gray-300"} transition-all ease-in-out duration-200 items-center`}>{props.name} { props.me ? (
                        <>
                            <FaCrown className="w-5" />
                        </>
                    ) : null}</a>
                    {
                        !isNaN(props.subscribers) ? (
                            <h3 className={`font-BreezeAltHeader font-medium text-md w-fit text-center text-gray-300`}>{parseInt(props.subscribers).toLocaleString("en-US")} subscribers</h3>
                        ) : null
                    }
                </div>
            </div>
        </>
    )
};